import React from 'react'
import { Col, Row } from 'antd'

export default function News ({ news }) {
  return (
    <Row style={{ background: 'linear-gradient(white, teal, white)' }}>
      <Col span={1} />
      <Col span={22}>
        {news}
      </Col>
      <Col span={1} />
    </Row>
  )
}
